import React, { useState } from 'react';

import { PrismicRichText } from '@prismicio/react';
import { primarySmallTheme, primaryTheme } from '@repo/ui/components/Buttons';
import ChevronRightIcon from '@repo/ui/components/Icon/ChevronRightIcon';
import { Spacer } from '@repo/ui/components/Spacer';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';
import LinkButton from 'components/LinkButton/LinkButton';
import { getMediaCdnUrl } from 'global/prismicUtils';
import useWindowSize from 'global/utils/useWindowSize';

import ResponsiveSpacer from '../../components/ResponsiveSpacer/ResponsiveSpacer';

import {
  TabWrapper,
  TabButton,
  ChevronButton,
  ContentGrid,
  Title,
  TabTitle,
  Text,
  ImageContainer,
} from './styles';

const Tabs = ({ tabs, selectedTab, setSelectedTab }) => {
  const { isMobile } = useWindowSize();
  const [selectedIndex, setSelectedIndex] = useState(2);
  const mobileTabList = tabs.slice(selectedIndex - 2, selectedIndex);

  const onBackwards = () => {
    if (selectedIndex > 2) {
      setSelectedIndex(selectedIndex - 1);
    }
  };

  const onForward = () => {
    if (selectedIndex < tabs.length) {
      setSelectedIndex(selectedIndex + 1);
    }
  };

  if (isMobile) {
    return (
      <TabWrapper>
        <ChevronButton
          rotateIcon
          disabled={selectedIndex === 0}
          onClick={onBackwards}
        >
          <ChevronRightIcon height="12px" />
        </ChevronButton>
        {mobileTabList.map((tab) => {
          return (
            <TabButton
              key={tab.tabName}
              selected={selectedTab === tab.tabName}
              onClick={() => setSelectedTab(tab.tabName)}
            >
              {tab.tabName}
            </TabButton>
          );
        })}
        <ChevronButton
          disabled={selectedIndex === tabs.length}
          onClick={onForward}
        >
          <ChevronRightIcon height="12px" />
        </ChevronButton>
      </TabWrapper>
    );
  }

  return (
    <TabWrapper>
      {tabs.map((tab) => {
        return (
          <TabButton
            key={tab.tabName}
            selected={selectedTab === tab.tabName}
            onClick={() => setSelectedTab(tab.tabName)}
          >
            {tab.tabName}
          </TabButton>
        );
      })}
    </TabWrapper>
  );
};

const TabShowcase = ({ slice }) => {
  const { primary, items: tabs } = slice;
  const { title } = primary;
  const [selectedTab, setSelectedTab] = useState(tabs[0].tabName);
  const selectedTabData = tabs.find((tab) => tab.tabName === selectedTab);
  const { isMobile } = useWindowSize();

  return (
    <ContentWrapper
      background={slice.primary.background || 'white'}
      className="tab-showcase"
      customWidth="1100px"
    >
      <Spacer height="46px" />
      <Title>{title}</Title>
      <Spacer height="24px" />
      <Tabs
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        tabs={tabs}
      />
      <ResponsiveSpacer dh="68px" mh="24px" />
      <ContentGrid>
        <ImageContainer>
          {selectedTabData.image?.url && !selectedTab.video?.url && (
            // eslint-disable-next-line @next/next/no-img-element
            <img
              alt="Promotional showcase"
              src={getMediaCdnUrl(selectedTabData.image.url)}
            />
          )}
          {selectedTabData.video?.url && (
            <video autoPlay loop muted playsInline controls={false}>
              <source src={getMediaCdnUrl(selectedTabData.video.url)} />
            </video>
          )}
        </ImageContainer>
        <div style={{ gridArea: 'text', flex: 1 }}>
          <TabTitle>{selectedTabData.title}</TabTitle>
          <Text as="div">
            <PrismicRichText field={selectedTabData.text} />
          </Text>
          <Spacer height="32px" />
          {!isMobile && (
            <LinkButton
              height="40px"
              href={selectedTabData.buttonUrl.url}
              label={selectedTabData.buttonLabel}
              theme={primaryTheme}
              width="auto"
            />
          )}
        </div>
        {isMobile && (
          <div style={{ gridArea: 'button', textAlign: 'center' }}>
            <Spacer height="24px" />
            <LinkButton
              href={selectedTabData.buttonUrl}
              label={selectedTabData.buttonLabel}
              theme={primarySmallTheme}
              width="auto"
            />
          </div>
        )}
      </ContentGrid>
      <Spacer height="100px" />
    </ContentWrapper>
  );
};

export default TabShowcase;
